import BaseModel from '../core/BaseModel'
export default class OfficeAgencyModel extends BaseModel {

    constructor() {
        super({ 
                name: "office_agency",
                tableName: 'office_agency', 
                label: "Quản lý cơ quan", 
                display_key: 'name', 
                default_order: { key: 'id', direction: 'asc' } }, 
            {
            // stt: {
            //     name: "stt",
            //     label: "STT",
            //     type: "Computed",
            //     computed: (data, index) => {
            //         data.stt = index + 1;
            //     },
            //     // display: { list: true, add: false, edit: false }
            // },
            id: { 
                name: 'id', 
                type: "Int", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            code: {
                name: 'code', 
                type: "String",
                label: 'Mã cơ quan',
                width :15,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            name: {
                name: 'name', 
                type: "String",
                label: 'Tên cơ quan',
                width :15, 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                width :15, 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            tax_code: {
                name: 'tax_code', 
                type: "String",
                label: 'Mã số thuế',
                width :15,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            phone: {
                name: 'phone', 
                type: "String",
                label: 'Số điện thoại',
                width :10,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            agency_tpl: {
                name: 'agency_tpl', 
                type: "String",
                label: 'Văn phòng quản lý',
                width :15,
                class: "center", 
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
        },)
    }

}